// Shared by the homepage and /diagnose so the two refinement lanes cannot
// drift apart on geometry again.

// Top of the usable viewport. The sticky header (components/ui/header.tsx) is
// 70px on mobile and 78px on desktop, so an element whose top sits above this
// line is tucked under the pill and is not actually visible to the user.
export const STICKY_HEADER_OFFSET = 80

/**
 * Bring a refinement destination into view without yanking the page when it is
 * already on screen. `offscreenBlock` is 'start' for cards that sit near the
 * top of the document: 'center' on a short card there resolves to roughly y=0,
 * clamps, and reads as a jump to the top of the page. Target sections carry
 * `scroll-mt-24`, so 'start' lands them under the header.
 *
 * Returns true when a scroll was issued.
 */
export function scrollRefinementTargetIntoView(
  id: string,
  offscreenBlock: ScrollLogicalPosition = 'start',
): boolean {
  const target = document.getElementById(id)
  if (!target) return false
  const box = target.getBoundingClientRect()
  const viewportHeight = window.innerHeight || document.documentElement.clientHeight
  const fullyVisible = box.top >= STICKY_HEADER_OFFSET && box.bottom <= viewportHeight
  if (fullyVisible) return false
  const partiallyVisible = box.top < viewportHeight && box.bottom > 0
  target.scrollIntoView({ behavior: 'auto', block: partiallyVisible ? 'nearest' : offscreenBlock })
  return true
}
